import React from "react";
import { Clock, Zap, Smile, Users, Home } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { useI18n } from "@/i18n";

const ICONS = [<Clock size={18} />, <Zap size={18} />, <Smile size={18} />, <Users size={18} />, <Home size={18} />];

export function EmployeeBenefits() {
  const { t } = useI18n();
  const e = t.employee;
  return (
    <section id="employee" className="bg-secondary py-24 md:py-32 border-y border-border">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 grid lg:grid-cols-2 gap-14 lg:gap-20 items-center">
        <Reveal className="order-2 lg:order-1">
          <div className="relative overflow-hidden border border-border">
            <img
              src="https://images.pexels.com/photos/20562278/pexels-photo-20562278.jpeg"
              alt="Private jet cabin"
              className="w-full h-[520px] object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-midnight/40 to-transparent" />
          </div>
        </Reveal>

        <Reveal delay={0.1} className="order-1 lg:order-2">
          <p className="overline text-accent">{e.overline}</p>
          <h2 className="mt-4 font-serif text-4xl md:text-6xl tracking-tight leading-[1.02]">{e.title}</h2>
          <ul className="mt-10 space-y-5">
            {e.items.map((it, i) => (
              <li key={i} className="flex items-center gap-4" data-testid={`employee-item-${i}`}>
                <span className="grid place-items-center h-10 w-10 rounded-full bg-pine text-cream">{ICONS[i]}</span>
                <span className="text-foreground/90 text-lg">{it}</span>
              </li>
            ))}
          </ul>
        </Reveal>
      </div>
    </section>
  );
}
